import React, { createRef, forwardRef, useEffect, useState } from 'react'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from '../../AuthContext'
import {
  Title,
  PrimaryOutlineButton,
  SubtitleOpen,
} from '../../Utils/CustomClasses'
import styled from 'styled-components'
import useInterval from '../../Hooks/UseInterval'
import { useSpring, animated } from '@react-spring/web'

const LatestActivityWrapper = styled.div`
  overflow: hidden;
`

const LatestActivityTitle = styled(Title)`
  font-size: 18px !important;
`

const ActivityName = styled.div`
  display: flex;
  gap: 5px;
  flex-wrap: nowrap;
`

const BreakSub = styled(SubtitleOpen)`
  display: flex;
  overflow-wrap: anywhere;
  font-color: #941e15 !important;
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 400;
  margin: 4px 0 0 0;
`

const BreakSubActivity = styled(BreakSub)`
  width: 125px;
  font-weight: 300;
  font-size: 16px;

  b {
    font-weight: 600;
  }
`

const BreakSubActivityRight = styled(BreakSubActivity)`
  font-size: 16px;
  width: -webkit-fill-available;
`

const ActivityText = styled(SubtitleOpen)`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 300;
  margin: 8px 0 0;
`

const LatestActivity = ({ user }) => {
  const [dataArr, setDataArr] = useState([])
  const [results, setResults] = useState([])
  const [startPoint, setStartPoint] = useState(0)
  const [interval, setInterval] = useState(5000)
  const [updateCount, setUpdateCount] = useState(0)

  useEffect(() => {
    retrieveData(startPoint)
  }, [])

  const retrieveData = (startPoint) => {
    axios
      .get(`/api/VYGVA82re2f8e2/latestactivity?sp=${startPoint}&uid=${user.id}`)
      .then((response) => {
        const data = response.data.map((d, index) => {
          return (
            <LatestActivityComponent
              ref={createRef()}
              key={index}
              num={index}
              u={d.forename}
              activityType={'SIGNUP'}
              color={'#3DBD7E'}
              activityText={
                d.forename + ' signed up from ' + d.country.nicename
              }
            />
          )
        })

        data.reverse()

        setDataArr(data)
      })
      .catch((err) => {
        console.log('Error getting latest featured activity: ', err)
      })
  }

  useEffect(() => {
    setResults(dataArr.slice(dataArr.length - 4, dataArr.length))
  }, [dataArr])

  useEffect(() => {
    handleAnimation()
  }, [results])

  useEffect(() => {
    retrieveData(startPoint)
  }, [startPoint])

  useInterval(() => {
    let range = { min: 5, max: 40 }
    let delta = range.max - range.min
    var rand = Math.round(range.min + Math.random() * delta)
    rand = rand * 1000
    setInterval(rand)
    const newStartPoint = startPoint + 1
    setStartPoint(newStartPoint)
  }, interval)

  const [springs, api] = useSpring(() => ({
    from: { y: 0 },
  }))

  const [springs2, api2] = useSpring(() => ({
    from: { y: 0 },
  }))

  const handleAnimation = () => {
    if (updateCount === 0) {
      setUpdateCount(1)
    } else {
      api.start({
        config: { duration: 500 },
        from: {
          x: -400,
        },
        to: {
          x: 1,
        },
      })
      api2.start({
        config: { duration: 200 },
        from: {
          y: -200,
        },
        to: {
          y: 0,
        },
      })
    }
  }

  const LatestActivityComponent = forwardRef(
    ({ num, u, activityType, color, activityText }, ref) => {
      return (
        <animated.div
          style={
            num == 3
              ? {
                  margin: '0 0 40px 0',
                  ...springs,
                }
              : {
                  margin: '0 0 40px 0',
                  ...springs2,
                }
          }
          ref={ref}
        >
          <LatestActivityTitle color={color} size="18px">
            {activityType}
          </LatestActivityTitle>
          <ActivityName>
            <BreakSubActivity>
              <b>Name:</b>
            </BreakSubActivity>
            <BreakSubActivityRight>{u}</BreakSubActivityRight>
          </ActivityName>
          <ActivityText>{activityText}</ActivityText>
        </animated.div>
      )
    }
  )

  if (!results) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ margin: '100px auto 100px', opacity: '0.3' }}
          role="status"
        ></div>
      </div>
    )
  }
  return (
    <LatestActivityWrapper className="resultsWrapper">
      {results}
    </LatestActivityWrapper>
  )
}

export default withRouter(withAuth(LatestActivity))
